import { Box } from "@mui/material";

const AssementButton = ({
  text,
  width = "auto",
  color,
  onButtonClick,
  backgroundColor = "white",
  btncolor = "",
}) => {
  const label = Number.isFinite(text) && text < 10 ? `0${text}` : String(text ?? "");

  return (
    <Box
      onClick={onButtonClick}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1,
        py: 1,
        px: 0.75,
        cursor: "pointer",
        minWidth: 52,
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 28,
          flexShrink: 0,
          textAlign: "right",
          fontVariantNumeric: "tabular-nums",
          lineHeight: 1.2,
        }}
      >
        {label}.
      </Box>
      <Box
        sx={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: btncolor,
          flexShrink: 0,
        }}
      />
    </Box>
  );
};
export default AssementButton;
